module.exports = __webpack_public_path__ + "static/img/son7.7e727df7.jpg";